module.exports = __webpack_public_path__ + "static/favicon-2508b9f8426ba595c60e935039ba24cd.png";